<script lang="ts">
  import { getNextSessions, saveRegistration, } from '../api';
  import type { IRegistration, ISession } from '../api/entities';
  import { setTitle } from '../stores/titles';
  import { notifyError, notifySuccess } from '../stores/notifications';
  import { formatDate, pluralize } from '../utils';
  import Session from './Session.svelte';
  import RegisterForm from './RegisterForm.svelte';
  import Loader from './Loader.svelte';

  const askConfirm = () => {
    confirmation = true;
  };

  const validateRegistration = async () => {
    try {
      await saveRegistration(registration);
      promise = getNextSessions();
      registration = undefined;
      confirmation = false;
      notifySuccess('Votre inscription est bien prise en compte !');
    }
    catch {
      notifyError('Oups, une erreur est survenue...');
    }
  };

  const backToSessionChoice = () => { registration = undefined; }

  const backToForm = () => { confirmation = false; }

  $: promise = getNextSessions();

  let registration: IRegistration;
  let confirmation = false;
  let selectedSession: ISession|undefined;

  const newRegistration = (sessionId: string) => {
    return {
      sessionId,
      name: '',
      phone: '',
      nbAdults: 1,
      children: [{ age: 5 }],
    }
  };

  setTitle('Inscription aux activités disponibles');
</script>

<style lang="scss">
  @import "../styles/bulma.override";

	.session-button {
		height: unset !important;
    display: block;
    width: 100%;
	}

  @include mobile {
    .p-5 {
      padding: 0 !important;
    }
  }
</style>

<section class="columns is-centered is-multiline">
  {#if !registration && !confirmation}
    {#await promise}
      <Loader />
    {:then result}
      {#if result.sessions?.length > 0}
        <p class="column is-full is-size-4">
          Cliquez sur l'activité de votre choix
        </p>

        {#each result.sessions as session}
        <div class="column is-one-quarter-desktop is-half-tablet">
          <button
            class="session-button button is-info is-light"
            on:click={() => {
              selectedSession = session;
              registration = newRegistration(session._id);
            }}
          >
            <Session
              session={session}
              nbAvailablePlaces={result.availablePlacesBySession[session._id]}
            />
          </button>
        </div>
        {/each}
      {:else}
        <p class="column is-full is-size-4">
          Aucun atelier n'est ouvert pour l'instant...
          <br />
          D'autres seront rajoutés bientôt, n'hésitez pas à revenir :)
        </p>
      {/if}
    {/await}
  {/if}

  {#if registration && !confirmation}
    <p class="column is-full is-size-4">
      Remplissez le formulaire pour vous inscire à l'activité "{selectedSession?.name}"
    </p>

    <div class="column is-two-thirds-desktop">
      <RegisterForm
        registration={registration}
        validate={askConfirm}
        cancel={backToSessionChoice}
      />
    </div>
  {/if}

  {#if confirmation}
    <p class="column is-full is-size-4">
      Confirmer l'inscription
    </p>

    <p class="column is-full">
      Vous êtes sur le point de vous inscrire pour la {selectedSession?.name} le {formatDate(selectedSession?.date, { withDate: true, withTime: true })}
    </p>

    <p class="column is-full">
  Il s'agit de {registration.nbAdults} {pluralize('adulte', registration.nbAdults)} et {registration.children.length} {pluralize('enfant', registration.children.length)} de {[...new Set(registration.children.map(e => e.age))].join(' et ')} ans.
    </p>

    <p class="column is-full">
      <button class="button is-primary is-medium" on:click={validateRegistration}>Confirmer</button>
      <button class="button is-outlined is-medium" on:click={backToForm}>Annuler</button>
    </p>
  {/if}
</section>